/*
 * @Description: 通用正则
 * @Author: maxiangrui
 * @Date: 2021-04-27 09:59:43
 * @LastEditors: maxiangrui
 * @LastEditTime: 2021-06-07 16:03:53
 */

export default {
  // 手机号
  mobile: /^1[3584796]\d{9}$/,

  // 座机
  phone: /^0\d{2,3}-?\d{7,8}$/,

  // 手机号或座机号
  mobilephone: /^1[3584796]\d{9}$|^0\d{2,3}-?\d{7,8}$/,

  // 中文
  chinese: /[\u4e00-\u9fa5]/g,

  // 英文
  english: /[a-zA-Z]/g,

  // 8位,匹配字母或数字或下划线
  eightPlaces:  /^\w{1,8}$/,

  // 22位正整数数字包含0
  integerNumber:  /^[0-9]\d{0,21}$/
}



// WEBPACK FOOTER //
// ./src/utils/regExp.js